import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollRestoration() {
  const [scrollPositions, setScrollPositions] = useState({});
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const path = location.pathname;
    if (navigationType === 'POP') {
      if (Object.keys(scrollPositions || {}).includes(path)) {
        const pos = scrollPositions[path];
        window.scrollTo(0, pos);
      }
    } else {
      window.scrollTo(0, 0);
    }

    return () => {
      setScrollPositions((prev) => ({
        ...prev,
        [path]: window.scrollY,
      }));
    };
  }, [location.pathname, navigationType]);

  return (
          <Outlet />

  );
}
